import { ListOf } from 'app/redux/models/common/ListOf'

import { SecurityHistoryItem } from './SecurityHistoryItem.js'

/**
 * @class
 * @typedef {Array.<SecurityHistoryItem>} SecurityHistoryList
 */
export class SecurityHistoryList extends ListOf(SecurityHistoryItem) {}
